<template>
    <div class="complaint--products">
        <div class="complaint--form-title">Reklamációhoz kapcsolódó termékek</div>
        <div class="complaint--form-datas">

            <div v-if="selectedProducts.length > 0">
                <div class="selected--products-list">
                    <div v-for="(product, index) in selectedProducts" :key="index" class="selected-product-item">
                        <span>{{ product.product_number }} - {{ product.name }}</span>
                        <div class="selprodcont">
                            <div class="complaint--form-input">
                                <label
                                    class="text-input-label">
                                    Mértékegység - {{ product.unit }}
                                </label>
                                <input
                                    v-model="product.amount"
                                    :disabled="disabled"
                                    type="number"
                                    placeholder="Mennyiség"
                                    min="1"
                                    @input="debouncedUpdateAmount(product)"/>
                            </div>
                            <button :disabled="disabled" @click="removeProduct(product)">Törlés</button>
                        </div>
                    </div>
                </div>
            </div>
            <div class="selected--products-list-empty" v-else>
                <p>Nincs kiválasztott termék</p>
            </div>

            <hr>

            <div class="search-container">
                <search :input="search" :searchData="searchData" @searchPhrase="onSearchPhraseChanged" :disabled="disabled"></search>

                <custom-table
                    ref="table"
                    :columns="tableColumns"
                    :pages="productListPages"
                    :meta="productListMeta"
                    @remove-page="removePage"
                    @load-page="loadPage"
                    @on-row-click="onRowClick">
                    <template slot="table-row" slot-scope="props">
                        {{ props.formattedRow[props.column.field] }}
                    </template>
                    <div slot="empty_state">{{ $t('product.page.list.text.empty_state') }}</div>
                </custom-table>
            </div>
        </div>
    </div>
</template>

<script>
import Search from '../components/Search.vue'
import {mapGetters} from 'vuex'
import CustomTable from '../components/CustomTable'
import axios from 'axios';
import config from '../plugins/config.js'

export default {
    name: "ComplaintProducts",
    components: {
        Search,
        CustomTable
    },
    props: {
        complaint: {
            required: true
        },
        disabled: {
            required: false,
            default: false
        }
    },
    data() {
        return {
            loading: false,
            search: '',
            selectedProducts: [],
            productGroups: [],
            searchTimer: null,
            amountTimer: null,
            tableColumns: [
                {
                    label: this.$t('product.page.list.column.product_number'),
                    field: 'productNumber',
                },
                {
                    label: this.$t('product.page.list.column.name'),
                    field: 'name',
                },
                {
                    label: this.$t('product.page.list.column.type'),
                    field: 'type',
                },
            ]
        }
    },
    mounted() {
        this.fetchComplaintProducts();
    },
    methods: {
        onRowClick(params) {
            if (!this.selectedProducts.some(product => product.productNumber === params.row.productNumber)) {
                this.addProduct(params.row)
            }
        },

        addProduct(product) {
            if (!product.amount) {
                product.amount = 1;
            }
            this.loading = true;
            axios.post(`/complaints/${this.complaint}/add-product`, {product: product}, config.AXIOS_DEFAULTS)
                .then(response => {
                    this.$store.commit('setNotification', [response.message])
                    this.$emit('updated', true)
                    this.fetchComplaintProducts();
                })
                .catch(error => {
                    console.error("Error adding product:", error);
                    this.$store.commit('setNotification', [error.message])
                });
        },

        removeProduct(product) {
            this.loading = true;
            axios.delete(`/complaints/${this.complaint}/products/${product.id}`, config.AXIOS_DEFAULTS)
                .then(response => {
                    this.$store.commit('setNotification', [response.message])
                    this.$emit('updated', true)
                    this.fetchComplaintProducts();
                })
                .catch(error => {
                    console.error("Error sending approval request:", error);
                    this.$store.commit('setNotification', [error.message])
                });
        },

        debouncedUpdateAmount(product) {
            if (this.amountTimer) {
                clearTimeout(this.amountTimer);
            }
            this.amountTimer = setTimeout(() => {
                this.updateAmount(product);
            }, 500);
        },

        updateAmount(product) {
            if (!product.amount) {
                return
            }

            this.loading = true;
            axios.post(`/complaints/${this.complaint}/${product.id}/update-product-amount`, {
                amount: product.amount
            }, config.AXIOS_DEFAULTS)
                .then(response => {
                    this.$store.commit('setNotification', [response.message]);
                    this.$emit('updated', true)
                    this.loading = false;
                })
                .catch(error => {
                    console.error("Error updating product amount:", error);
                    this.$store.commit('setNotification', [error.message]);
                    this.loading = false;
                });
        },

        loadPage(page) {
            this.loading = true
            this.$store.dispatch('FETCH_PRODUCTS', {page, keepOtherPages: true}).then(() => {
                this.loading = false
            })
        },

        refresh() {
            this.loading = true
            this.$store.dispatch('FETCH_PRODUCTS', {page: 1, keepOtherPages: false}).then(() => {
                this.loading = false
                this.$refs.table?.scrollToTop()
            })
        },

        removePage(page) {
            this.$store.commit('removeProductListPage', page)
        },

        onSearchPhraseChanged(phrase) {
            if (phrase.length === 0) {
                this.$store.commit('resetProducts')
            }

            if (this.searchTimer) {
                clearTimeout(this.searchTimer)
                this.searchTimer = null
            }

            if (this.search === phrase) {
                return
            }

            this.searchTimer = setTimeout(() => {
                this.searchTimer = null
                this.$store.commit('setProductListActiveFilters', {
                    ...this.productListActiveFilters,
                    search: phrase.length > 0 ? phrase : void 0
                })
                this.refresh()
            }, 300)
        },

        fetchProducts() {
            this.loading = true
            this.$store.dispatch('FETCH_PRODUCT_GROUPS').then(data => {
                this.productGroups = data;
                this.$store.dispatch('FETCH_PRODUCTS', {page: 1, keepOtherPages: false}).then(() => {
                    this.loading = false
                })
            })
        },

        fetchComplaintProducts() {
            axios.get(`/complaints/${this.complaint}/products`, config.AXIOS_DEFAULTS)
                .then(response => {
                    this.selectedProducts = response;
                })
                .catch(error => {
                    console.error("Error sending approval request:", error);
                    this.$store.commit('setNotification', [error.message])
                });
        }
    },
    computed: {
        searchData() {
            return {
                placeholder: this.$t('product.page.list.search.placeholder'),
                tooltipText: this.$t('product.page.list.search.tooltip'),
                countText: this.$tc('product.page.list.search.name', this.productListMeta.total)
            }
        },

        ...mapGetters(['productListPages', 'productListMeta', 'productListTypes', 'productListActiveFilters'])
    },
}
</script>
